<template>
  <div class="files">
    <FileAttachment v-for="(file, index) in agendaFiles" :key="index" :file="file"></FileAttachment>
    <FileAttachmentSkeleton v-for="(file, index) in blankFiles" :key="`skeleton-file-${index}`"></FileAttachmentSkeleton>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import FileAttachment from './FileAttachment.vue';
  import FileAttachmentSkeleton from './FileAttachmentSkeleton.vue';

  export default {
    name: 'FileAttachments',
    components: {
      FileAttachment,
      FileAttachmentSkeleton,
    },
    props: ['item'],
    computed: {
      agendaFiles() {
        return this.item.hasOwnProperty('agendaFiles') ? this.item.agendaFiles : [];
      },
      numBlankFiles() {
        return this.agendaFiles.length === 0 ? 1 : 0;
      },
      blankFiles() {
        return this.numBlankFiles ? lodash.map(Array(this.numBlankFiles), item => ({})) : [];
      },
    },
  };
</script>

